export default __webpack_public_path__ + "images/bab4f6178e02bbca698ecfdea4b6fa01-realestate.jpg";